import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { Box, CircularProgress } from "@mui/material";
import { selectIsAuthenticated, selectAuthLoading } from "../store/slices/authSlice";

// This page is kept as a safety net for any old magic-link URLs still in circulation.
// Google OAuth completes in the popup — no callback page is needed.
export default function AuthCallback() {
  const navigate = useNavigate();
  const isAuthenticated = useSelector(selectIsAuthenticated);
  const authLoading = useSelector(selectAuthLoading);

  useEffect(() => {
    if (!authLoading) {
      navigate(isAuthenticated ? "/" : "/login", { replace: true });
    }
  }, [authLoading, isAuthenticated, navigate]);

  return (
    <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh" bgcolor="#f8fafc">
      <CircularProgress size={32} sx={{ color: "#2563eb" }} />
    </Box>
  );
}
